export const yaantracURLs = {
  // Dashboard
  ANALYTICS: 'user/live/timescale/dashboard',
  VEHICLE_MAKE: 'user/live/timescale/dashboard/filter/make',
  CATEGORY_SELECT: 'user/live/timescale/vehicle/details/dropdown?',
  OVERVIEW: 'user/timescale/overview/dashboard?',

  // dashboard
  DASHBOARD_VEHICLES: 'user/dashboard/vehicles',
  DASHBOARD_VEHICLES_COUNT: 'map/live/count',
  DASHBOARD_VEHICLES_STATUS: 'map/filter/status?status=',
  DASHBOARD_LOCATION_RADIUS: 'user/livetracking/searchdevice',
  SPEED_FREQUENCY: 'map/speed/frequency?deviceid=',

  // historic tracking
  GET_HISTORIC_TRACKING: 'user/timescale/history/tracking?',

  // trips
  TRIP_DETAILS: 'trip/details',
  TODAY_TRIP_DETAILS: 'map/trip/0h',
  TRIP_DEVICE_DETAILS: 'map/active/vehicles',
  MAPPED_TRIP_DEVICE_DETAILS: 'trip/mapped/device/details',
  PREVIEW_TRIP: 'trip/preview',
  ADD_TRIP: 'trip/v2/add',
  UPDATE_TRIP: 'trip/v2/update',
  DEACTIVATE_TRIP: 'trip/deactivate',
  SHARE_TRIP: 'trip/share',
  Trip_Tracking: 'trip/link/validation?',
  DELETE_TRIPS: 'trip/delete',
  TRIP_VEHICLE_FILTER: 'map/filter/vehicle',

  // live status
  LIVE_STATUS: 'user/livetracking/livestatus',

  // geofence
  GET_VEHICLE_LIST: 'user/geofence/vehicle',
  GET_GEOFENCES: 'user/geofence/new/get',
  ADD_GEOFENCE: 'user/geofence/new/add',
  UPDATE_GEOFENCE: 'user/geofence/new/update?',
  DEACTIVATE_GEOFENCE: 'user/geofence/circular/deactivate?',
  DELETE_GEOFENCE: 'user/geofence/new/delete?geozoneid=',
  ADD_GEOFENCE_MAPPING: 'user/geofence/add/remove/map?',
  GEOFENCE_MAPPING_LIST: 'user/geofence/v2/get/status?',

  // overspeed
  GET_OVERSPEED_DETAILS: 'user/report/overspeed/details',
  GET_VEHICLES_DETAILS: 'user/report/get/vehicle?',
  UPDATE_OVERSPEED_DETAILS: 'user/report/device/update/overspeed?',
  UPDATE_YAANTRAC_VEHICLE: 'user/report/update/vehicle',
  GET_VEHICLE_LIST_DETAILS: 'user/report/vehicle/details?',
  GET_SINGLE_VEHICLE_DETAILS: 'user/report/vehicle?',

  // my location
  GET_MY_LOCATION: 'user/mylocation/get/all',
  ADD_MY_LOCATION: 'user/mylocation/add',
  UPDATE_MY_LOCATION: 'user/mylocation/update?',
  DELETE_MY_LOCATION: 'user/mylocation/delete?',
  PIN_MY_LOCATION: 'user/mylocation/pin?',

  // reports
  DEVICE_LIST: 'user/report/devices',
  KM_REPORT: 'user/timescale/km?',
  ENGINE_REPORT: `user/timescale/engine?`,
  STOPPAGE_REPORT: `user/timescale/stoppage?`,
  IDLE_REPORT: `user/timescale/idle?`,
  MOVEMENT_REPORT: `user/timescale/movement?`,
  PARKING_REPORT: `user/timescale/parking?`,
  OVERALL_REPORT: `user/timescale/overall?`,
  OVERSPEED_REPORT: 'user/timescale/overspeed?',
  ALERT_NOTIFICATION_REPORT: `user/timescale/alert?`,
  DETAILED_TRIP_REPORT: `user/timescale/trip?`,
  VEHICLE_LOGBOOK_REPORT: `user/influx/device/details/logbook?`,
  DEVICE_HEALTH_REPORT: `user/timescale/device-health?`,
  VEHICLE_GEOFENCE: `user/timescale/geofence?`,
  VEHICLE_DETAILS: `user/timescale/vehicle/details?`,
  DRIVER_SCORECARD: `user/timescale/driverscorecard?`,
  REPORT_PDF: `user/timescale/download/report?`,
  REPORT_EXCEL: `user/timescale/download/report?`,
  SEND_MAIL: `user/timescale/event`,
  IDENTIFICATION_REPORT: `user/timescale/driver/identification?`,
  COMPLIANCE_REPORT: `user/timescale/trip/compliance?`
};
